import React from 'react';
import map from 'lodash/map';

import Dropdown from 'src/presentation/components/forms/Dropdown';
import { getFriendlyName } from 'src/presentation/components/pages/sidekick/threads/utils/utils';
import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import { SelectOption } from 'src/presentation/components/pages/sidekick/threads/components/SidePanel/Components/Rule/helpers/memoriesHelper';

const EnumControl = ({
  'data-aid': dataAid,
  attr,
  description,
  disabled,
  typeSpec,
}: {
  'data-aid'?: string;
  attr: string;
  description?: string;
  disabled: boolean;
  typeSpec: TypeSpec;
}) => {
  const opts: SelectOption[] = map(
    typeSpec.enum,
    (v: string): SelectOption => ({
      label: getFriendlyName(v),
      value: v,
    })
  );

  return (
    <Dropdown
      attr={attr}
      data-aid={dataAid}
      description={description}
      disabled={disabled}
      fitOpenerWidth={false}
      label={(typeSpec as any).prompt}
      options={opts}
    />
  );
};

export default EnumControl;
